import React from "react";

// Embeds a GoHighLevel / LeadConnector inline form so all submissions
// flow directly into the client's CRM. The global form_embed.js script
// (loaded once in index.html) handles iframe resizing via postMessage.
const FORM_ID = "D9d3waI637dlZhtiV2wt";
const FORM_NAME = "New Client From";

const GHLForm = ({ height = 1173, className = "", instanceId = "" }) => {
  const domId = `inline-${FORM_ID}${instanceId ? `-${instanceId}` : ""}`;

  return (
    <iframe
      data-testid="ghl-lead-form"
      src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`}
      style={{ width: "100%", height: `${height}px`, border: "none", borderRadius: "12px" }}
      id={domId}
      className={className}
      data-layout="{'id':'INLINE'}"
      data-trigger-type="alwaysShow"
      data-trigger-value=""
      data-activation-type="alwaysActivated"
      data-activation-value=""
      data-deactivation-type="neverDeactivate"
      data-deactivation-value=""
      data-form-name={FORM_NAME}
      data-height={height}
      data-layout-iframe-id={domId}
      data-form-id={FORM_ID}
      title={FORM_NAME}
    />
  );
};

export default GHLForm;
